<template>
<div class="chapter">
<div class="inner_page">
<p class="dedic1"><i>For Rachael, whose unconditional love and unwavering support are never-ending</i></p>
<p class="dedic">—David</p>
<p class="dedic1"><i>For Henry Waylon Sinibaldi and Melrose Anne Stoval, the two latest members of my favorite team </i></p>
<p class="dedic">—Raymond</p>
<p class="dedic1"><i>To Pam, whose endless patience allowed me to devote all the time necessary to a project such as this </i></p>
<p class="dedic">—Kerry</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?4c9877e0